import ListingSearchItem from "@/components/listing/ListingSearchItem";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { ListingSearchData } from "@/lib/types/search";
import { useTranslations } from "next-intl";
import Image from "next/image";
import React from "react";
import { IMAGE_SIZES } from "@/lib/imageSizes";

type Props = {
  items: Array<ListingSearchData>;
  isLoading: boolean;
  reset: () => void;
};

const SearchResults: React.FC<Props> = ({ items, isLoading, reset }) => {
  const t = useTranslations("search");
  return (
    <div>
      {items.length === 0 && !isLoading && (
        <div className="flex flex-col items-center justify-center gap-4 py-16">
          <Image
            src="/assets/logo-gray.webp"
            alt="Logo"
            width={200}
            height={200}
            unoptimized
            sizes={IMAGE_SIZES.thumb128}
            className="h-32 w-32 rounded-full"
          />
          <p className="text-center text-xl">{t("no-results")}</p>
          <Button variant="outline" onClick={reset}>
            {t("clear-filters")}
          </Button>
        </div>
      )}
      <div className="grid grid-cols-1 gap-3 xl:grid-cols-2 xl:gap-4">
        {isLoading
          ? new Array(8)
              .fill(0)
              .map((_, index) => (
                <Skeleton
                  key={index}
                  className="h-[124px] w-full rounded-2xl lg:h-[160px]"
                />
              ))
          : items.map((item) => (
              <ListingSearchItem key={item.href} item={item} />
            ))}
      </div>
    </div>
  );
};

export default SearchResults;
